import axios from 'axios';
import { useState } from 'react';
import { baseurl } from '../common/baseUrl';

const useAxios = (initialValue = {}) => {
  const [response, setResponse] = useState({
    loading: false,
    error: null,
    data: initialValue,
  });
  console.log(localStorage.getItem('tokenCineplex'));
  const { loading, error, data } = response;
  const handleReset = () =>
    setResponse({
      loading: false,
      error: null,
      data: initialValue,
    });

  const fetcher = async ({ options, callback }) => {
    setResponse((prev) => ({
      ...prev,
      loading: true,
      error: null,
      data: initialValue,
    }));
    // setAuthToken();
    axios({
      ...options,
      url: baseurl + options.url,
    })
      .then(({ data }) => {
        if (data) {
          setResponse((prev) => ({
            ...prev,
            loading: false,
            error: null,
            data,
          }));
          // if any success message or function dispatch required, we can do this by passing this callback function
          if (typeof callback === 'function') {
            return callback();
          }
        }
      })
      .catch((error) => {
        setResponse((prev) => ({
          ...prev,
          loading: false,
          //   error: errorMsg(error) ?? convertErrorStatusToText(error),
          data: initialValue,
        }));
      });
  };

  return { fetcher, loading, error, data, handleReset };
};

export default useAxios;
